import { render, staticRenderFns } from "./MainHeaderMenuSports.vue?vue&type=template&id=84ba4ac8&scoped=true&"
import script from "./MainHeaderMenuSports.vue?vue&type=script&lang=js&"
export * from "./MainHeaderMenuSports.vue?vue&type=script&lang=js&"
import style0 from "./MainHeaderMenuSports.vue?vue&type=style&index=0&id=84ba4ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba4ac8",
  null
  
)

export default component.exports